import { render } from "./DetailsPost.vue?vue&type=template&id=290fbc48&scoped=true"
import script from "./DetailsPost.vue?vue&type=script&lang=js"
export * from "./DetailsPost.vue?vue&type=script&lang=js"

import "./DetailsPost.vue?vue&type=style&index=0&id=290fbc48&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-290fbc48"]])

export default __exports__